import React from "react";
import { createRoot } from "react-dom/client";
import NewsIndexIsland from "./NewsIndexIsland";

const mountNode = document.getElementById("news-index-island");

if (mountNode) {
  const rawConfig = mountNode.getAttribute("data-config");

  if (rawConfig) {
    const config = JSON.parse(rawConfig);
    createRoot(mountNode).render(<NewsIndexIsland config={config} />);
  }
}
